function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube:not(.js-autoplay)').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo:not(.js-autoplay)').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video:not(.js-autoplay)').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function syncHeaderMenuExpandedState() {
  document.querySelectorAll('.mega-menu__wrapper').forEach((wrapper) => {
    const trigger = wrapper.querySelector('.mega-menu__trigger');
    if (!trigger) return;

    const setExpanded = (expanded) => {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    setExpanded(wrapper.contains(document.activeElement));

    wrapper.addEventListener('mouseenter', () => setExpanded(true));
    wrapper.addEventListener('mouseleave', () => setExpanded(wrapper.contains(document.activeElement)));
    wrapper.addEventListener('focusin', () => setExpanded(true));
    wrapper.addEventListener('focusout', () => {
      requestAnimationFrame(() => setExpanded(wrapper.contains(document.activeElement)));
    });
  });
}

syncHeaderMenuExpandedState();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary:not(.classic-summary)').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('summary.classic-summary').forEach((summary) => {
      const detailsElement = summary.parentNode;
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', detailsElement.hasAttribute('open'));

      if (summary.nextElementSibling?.id) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
      }

      detailsElement.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', detailsElement.hasAttribute('open'));
      });
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((btn) => {
      btn.addEventListener(
        'click',
        this.hide.bind(this, false)
      );
    });
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    setTimeout(() => {
      if(this.dataset.autoplay){
        this.loadContent(false);
      }
    },0);
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      window.pauseAllMedia();
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
      const togglerButton = this.querySelector(".deferred-media__poster-button");
      if(this.dataset.customControls == "true" && togglerButton) {
        togglerButton.dataset.active = true;
        togglerButton.addEventListener('click', () => {
          let playVideo = togglerButton.dataset.active == "true"
            ? false : true;          
          togglerButton.dataset.active = playVideo;          

          const youtubeVideo = this.querySelector('.js-youtube');
          if(youtubeVideo) {
            playVideo
            ? youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
              : youtubeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            return;
          }
          const vimeoVideo = this.querySelector('.js-vimeo');
          if(vimeoVideo) {
            playVideo
            ? vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*')
              : vimeoVideo.contentWindow.postMessage('{"method":"pause"}', '*');
            return;
          }
          const videoElm = this.querySelector('video');
          if(videoElm) {
            playVideo
            ? videoElm.play()
              : videoElm.pause();
            return;
          };
        })
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.abortController = new AbortController();
    this.addEventListener('change', this.onVariantChange);
  }

  get sectionId() {
    return this.dataset.section;
  }

  get sourceSectionId() {
    return this.dataset.originalSection || this.sectionId;
  }

  onVariantChange(event) {
    this.updateOptions();
    publish(PUB_SUB_EVENTS.optionValueSelectionChange, { data: { event, selectedOptionValues: this.options } });
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateShortDetails();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`media-gallery[id^="MediaGallery-${this.sectionId}"]`);
    if (mediaGalleries.length > 0) {
      mediaGalleries.forEach((mediaGallery) => {
        if (typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(`${this.sectionId}-${this.currentVariant.featured_media.id}`, true);
        }
      });
    }

    const modalContent = document.querySelector(`#ProductModal-${this.sectionId} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (!newMediaModal) return;
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.sectionId}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment-${this.sectionId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOption = this.querySelector(':checked');
    if (!selectedOption) return;

    const selectedOptionOneVariants = this.variantData.filter((variant) => selectedOption.value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousSelectedInput = inputWrappers[index - 1].querySelector(':checked');
      if (!previousSelectedInput) return;

      const previousOptionSelected = previousSelectedInput.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const section = this.closest('section');
    const pickUpAvailability = section?.querySelector('pickup-availability') || document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.sourceSectionId;

    this.abortController.abort();
    this.abortController = new AbortController();

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`, {
      signal: this.abortController.signal,
    })
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (!this.currentVariant || this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.sectionId}`);
        const source = html.getElementById(`price-${sectionId}`);
        const skuSource = html.getElementById(`Sku-${sectionId}`);
        const skuDestination = document.getElementById(`Sku-${this.sectionId}`);
        const inventorySource = html.getElementById(`Inventory-${sectionId}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.sectionId}`);
        const priceWrapper = document.querySelector(`.td--price-container--${this.sectionId}`);
        const newPriceWrapper = html.querySelector(`.td--price-container--${sectionId}`);
        
        // ------------TD CHANGE-----------
        const syncedPriceSource = html.querySelector(`[data-price-sync-id="${sectionId}"]`);
       // ------------ END TD CHANGE-----------

        if (priceWrapper && newPriceWrapper) priceWrapper.innerHTML = newPriceWrapper.innerHTML
        if (source && destination) destination.innerHTML = source.innerHTML;

        // ------------TD CHANGE-----------
        if (syncedPriceSource) {
          document.querySelectorAll(`[data-price-sync-id="${this.sectionId}"]`).forEach((priceElement) => {
            priceElement.innerHTML = syncedPriceSource.innerHTML;
            priceElement.classList.toggle('visibility-hidden', syncedPriceSource.classList.contains('visibility-hidden'));
          });
        }
        // ------------ END TD CHANGE-----------
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.sectionId}`);
        if (price) price.classList.remove('visibility-hidden');

        if (inventorySource && inventoryDestination) {
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
        }

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      })
      .catch((error) => {
        if (error?.name === 'AbortError' || error?.code === 20) return;
        throw error;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.sectionId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.sectionId}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.sectionId}`);
    const inventory = document.getElementById(`Inventory-${this.sectionId}`);
    const sku = document.getElementById(`Sku-${this.sectionId}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateShortDetails() {
    const section = this.closest('section') || document;
    const detailsPerVariant = section.querySelectorAll('[data-short-details]');
    if (!detailsPerVariant.length) return;

    if (!this.currentVariant) {
      detailsPerVariant.forEach((el) => el.classList.add('td-hide'));
      return;
    }

    detailsPerVariant.forEach((el) => {
      if (el.dataset.shortDetails === String(this.currentVariant.id)) {
        el.classList.remove('td-hide');
      } else {
        el.classList.add('td-hide');
      }
    });
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


class TabButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    this.setAttribute('role', 'tab');
    this.setAttribute('aria-selected', this.classList.contains('td-active') ? 'true' : 'false');
    this.setAttribute('tabindex', this.classList.contains('td-active') ? '0' : '-1');
    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);

    if (this.classList.contains('td-active')) {
      this.expandShowMore();
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
  }

  get groupTabs() {
    return Array.from(document.querySelectorAll(`[data-general-id="${this.dataset.generalId}"]`));
  }

  get relatedPanels() {
    return Array.from(document.querySelectorAll(`[data-shared-id="${this.dataset.generalId}"]`));
  }

  get controlledPanel() {
    return document.querySelector(`[data-item-id="${this.dataset.tabId}"]`);
  }

  onClick(event) {
    this.expandShowMore(event);
  }

  onKeydown(event) {
    const tabs = this.groupTabs;
    if (!tabs.length) return;

    const currentIndex = tabs.indexOf(this);
    let nextTab = null;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        nextTab = tabs[(currentIndex + 1) % tabs.length];
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        nextTab = tabs[(currentIndex - 1 + tabs.length) % tabs.length];
        break;
      case 'Home':
        nextTab = tabs[0];
        break;
      case 'End':
        nextTab = tabs[tabs.length - 1];
        break;
      case ' ':
      case 'Enter':
        event.preventDefault();
        this.expandShowMore();
        return;
      default:
        return;
    }

    event.preventDefault();
    nextTab?.focus();
    nextTab?.expandShowMore();
  }

  expandShowMore(event) {
    event?.preventDefault();

    const displayElement = this.controlledPanel;
    if (!displayElement) return;

    this.relatedPanels.forEach((element) => {
      element.classList.add('td-hide');
      element.setAttribute('hidden', 'hidden');
      element.setAttribute('aria-hidden', 'true');
    });

    this.groupTabs.forEach((element) => {
      element.classList.remove('td-active');
      element.setAttribute('aria-selected', 'false');
      element.setAttribute('tabindex', '-1');
    });

    displayElement.classList.remove('td-hide');
    displayElement.removeAttribute('hidden');
    displayElement.setAttribute('aria-hidden', 'false');

    this.classList.add('td-active');
    this.setAttribute('aria-selected', 'true');
    this.setAttribute('tabindex', '0');
  }
}

customElements.define('tab-button', TabButton);

function backToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

function swymCallbackFn(swat){
  function swymAttachEvents(){
    swat.initializeActionButtons(".quick-add-modal__content");
  }
  document.addEventListener('quickview:loaded', function(e) {
    console.log("Quickview Loaded!",e.detail.productId);
    swymAttachEvents();
  });
}

if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);

const allPredictiveSearchTriggers = document.querySelectorAll('.predictive-search-trigger');

allPredictiveSearchTriggers?.forEach((trigger) => {
  trigger.addEventListener('click', () => {
    // Keep generic predictive-search triggers from hijacking active search UIs like the drawer field.
    if (trigger.closest('.menu-drawer, .search-modal, predictive-search, search-form')) return;

    const searchModalDetails = document.querySelector('details-modal.header__search details');
    searchModalDetails?.setAttribute('open', true);
  });
});

document.addEventListener('rebuy:cart.change', (event) => { 
  const smartcart = event.detail.cart.cart;
  if (!smartcart?.items?.length) return;
  const itemBundleGifts = smartcart.items.filter(li => li.properties['__bb-free-gift'] == "true");
  const itemRebuyGifts = smartcart.items.filter(li => 'Rebuy Gift with Purchase,Rebuy Tiered Progress Bar'.includes(li.properties['_attribution']));

  if (itemBundleGifts && itemRebuyGifts) {
    itemRebuyGifts.forEach((itemRebuyGift) =>{
      const matchGift = itemBundleGifts.find(li => li.variant_id == itemRebuyGift.variant_id);
      if(matchGift) {
        const dataForm = { id: matchGift.key, quantity: 0 };
        fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dataForm)
        })
          .catch(error => console.error('Error:', error));
      }
    })
  }
});

if (!customElements.get('rebuy-bundle-item')) {
  class RebuyBundleItem extends HTMLElement {
    constructor() {
      super();
      this.removeButton = null;
      this.toggleButton = null;
      this.detailsContainer = null;
      this.content = null;
    }

    connectedCallback() {
      this.setupRebuyEventHandlers();
    }

    setupRebuyEventHandlers() {
      if(this.closest('.td-bundle__active')) {
        this.removeButton = this.querySelector('[data-rebuy-bundle-remove]');
        this.toggleButton = this.querySelector('[rebuy-bundle-details-toggle]');
        this.setupRemoveButton();
        this.setupToggleButton();
      }

      document.addEventListener('rebuy:cart.change', () => {
        if(this.content && this.content.style.maxHeight) {
          setTimeout(() => {
            this.content.style.maxHeight = this.content.scrollHeight + 'px';
          }, 100);
        }
      });
    }

    setupRemoveButton() {
      if (this.removeButton && this.removeButton.dataset.listenerSetup !== 'true') {
        this.removeButton.dataset.listenerSetup = 'true';
        this.removeButton.addEventListener('click', () => {
          const bundleKeys = this.removeButton.getAttribute('data-rebuy-bundle-remove');
          if (!bundleKeys || bundleKeys.trim() === '') return;
          
          const keysArray = bundleKeys.split(',').map(key => key.trim()).filter(key => key);
          if (keysArray.length > 0) {
            const updates = {};
            keysArray.forEach((key) => {
              updates[key] = 0;
            });
            fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates }),
            })
              .then((response) => response.json())
              .then(() => {
                if (this.removeButton.dataset.afterAction === 'reload') {
                  location.reload();
                }
              })
              .catch((error) => {
                console.error('Error removing bundle items:', error);
              });
          }
        });
      }
    }

    setupToggleButton() {
      if (this.toggleButton && this.toggleButton.dataset.listenerSetup !== 'true') {
        this.toggleButton.dataset.listenerSetup = 'true';
        this.detailsContainer = this.querySelector('[rebuy-bundle-details]');
        this.content = this.querySelector('[rebuy-bundle-details-content]');
        if (!this.detailsContainer || !this.content) return;
        this.toggleButton.addEventListener('click', () => {
          if (this.detailsContainer.classList.contains('is-active')) {
            this.content.style.maxHeight = null;
          } else {
            this.content.style.maxHeight = this.content.scrollHeight + 'px';
          }
          this.detailsContainer.classList.toggle('is-active');
        });
      }
    }
  }
  customElements.define('rebuy-bundle-item', RebuyBundleItem);
}

document.addEventListener("rebuy:cart.change", (event) => {
  const smartcart = event.detail.cart.cart;
  const progressBars = document.querySelectorAll('[data-progress-bar="main"]');
  if (!progressBars || !smartcart) return;
  
  setTimeout(() => {
    const items = Rebuy.Cart.items();
    if (items.length > 0) {
      let quantity_progress = 0;
    
      for (const item of items) {
        const tags = item.product?.tags || item.tags || [];
        const properties = item.properties || {};
        const hasDiscountedTag = Array.isArray(tags) ? tags.includes('discounted') : `${tags}`.includes('discounted');
        const isExcludedItem = properties['__bb-free-gift'] || properties['__bb-bundle-item'] || properties['__bb-item'] === 'true';
        const hasGiftDiscount = item.discounts?.some((discount) => discount.title?.includes('Gift'));

        if (hasDiscountedTag && !isExcludedItem && !hasGiftDiscount) {
          quantity_progress += item.quantity;
        }
      }
      progressBars.forEach((progressBar) => {

        progressBar.querySelectorAll('.td-progress-bar__step-pill').forEach((pill, index) => {
          pill.classList.toggle('td-progress-bar__step-pill--active', index < quantity_progress);
        });
      });
    } else {
      progressBars.forEach((progressBar) => {
        progressBar.querySelectorAll('.td-progress-bar__step-pill').forEach(pill => {
          pill.classList.remove('td-progress-bar__step-pill--active');
        });
      });
    }
  }, 0);
  
  // const url = Shopify.routes.root + 'cart?view=progress-bar'; 

  // fetch(url)
  // .then(response => {
  //   if (!response.ok) {
  //     throw new Error(`HTTP error! status: ${response.status}`);
  //   }
  //   return response.text();
  // })
  // .then(responseText => {
  //   const tempDiv = document.createElement('div');
  //   tempDiv.innerHTML = responseText;
  //   const progressBarElement = tempDiv.querySelector('[data-progress-bar="main"]');

  //   if (progressBarElement) {
  //     // Get the HTML content of the progress bar
  //     const progressBarHTML = progressBarElement.innerHTML;

  //     // Get the actual progress bar element in the main document
  //     const actualProgressBarElement = document.querySelector('[data-progress-bar="main"]');

  //     if (actualProgressBarElement) {
  //       // Update the actual progress bar element with the extracted HTML
  //       actualProgressBarElement.innerHTML = progressBarHTML; 
  //       const newGifts = actualProgressBarElement.querySelectorAll('[data-add-gift="true"]');
  //       if (newGifts.length > 0) {
  //         const items_id = [];
  //         newGifts.forEach((gift) => {
  //           if(gift.dataset.stepGift) items_id.push(gift.dataset.stepGift);
  //         });
  //         if(items_id.length > 0) addGifts(items_id);
  //       }
  //     } else {
  //       console.warn("Element with data-progress-bar='main' not found in the main document.");
  //     }
  //   } else {
  //     console.warn("Element with data-progress-bar='main' not found in the response.");
  //   }
  // })
  // .catch(error => {
  //   console.error('Fetch failed:', error);
  // });
});


function addGifts(items_id) {
  const data = { items: [] };
  items_id.forEach((item) => {
    const gift = {
      id: item,
      quantity: 1,
    };
    data.items.push(gift);
  });

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((response) => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}

if (!customElements.get("td-video-modal")) {
  class tdVideoModal extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeModal();
    }

    initializeModal() {
      this.activeModalVideos = null;
      this.activeModal = null;
      this.volumeButton = this.querySelector('[volume-trigger]');
      this.modalOverlay = document.querySelector('.td-video-modal__overlay');
      this.slider = this.querySelector('swiper-slider');
      this.modalButtons = document.querySelectorAll('[modal-trigger]');
      
      this.modalButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          const selectedSlide = this.slider.querySelector(`#${button.getAttribute("target")}`);
          let targetIndex = null;
          if (selectedSlide) {
            targetIndex = Array.from(this.slider.slides).findIndex(slide => slide.id === selectedSlide.id);

          }
          this.activeModal = document.getElementById(button.getAttribute('modal-id'));
          this.activeModal && this.activeModal.hasAttribute('open') 
              ? this.close(this.activeModal) 
              : this.open(this.activeModal, targetIndex);
          this.scrollToTargetSlide(targetIndex);
        });
      });

      // Add a click handler to the document to close the modal when clicking outside
      document.addEventListener('click', (event) => {
        // Only close if we have an active modal and the click was outside it
        if (this.activeModal && !this.activeModal.contains(event.target)) {
          // Check if the click was on the volume button or its children
          const isVolumeButtonClick = this.volumeButton && 
            (this.volumeButton === event.target || this.volumeButton.contains(event.target));
          
          // Check if the click was on a modal trigger
          const isModalTriggerClick = event.target.closest('[modal-trigger]');
          
          // Only close if the click wasn't on the volume button or a modal trigger
          if (!isVolumeButtonClick && !isModalTriggerClick) {
            this.close(this.activeModal);
          }
        }
      });

      if (this.volumeButton) {
        this.volumeButton.addEventListener('click', (event) => {
          // Stop the click event from propagating to the document
          event.stopPropagation();
          this.toggleVolume();
        });
      } else {
        console.warn("Volume button is not found or not initialized.");
      }
    }

    open(modal, targetIndex) {
      this.activeModalVideos = modal.querySelectorAll('video');
      document.body.classList.add('scroll-hidden--mobile');
      this.modalOverlay.classList.add('td-video-modal__overlay--active');
      
      if (modal) {
        modal.setAttribute('open', '');
      }

      this.playVideo(targetIndex);
      this.setVideosVolume(.25);
    }

    scrollToTargetSlide(index) {
      this.slider.goToSlide({detail: {index: index}});
    }

    async playVideo(videoIndex) {
      if(this.activeModalVideos[videoIndex]) {
        try {
          // Store the play promise
          const playPromise = this.activeModalVideos[videoIndex].play();
          
          // If the browser supports promises, wait for it to complete
          if (playPromise !== undefined) {
            await playPromise;
            // Now it's safe to pause if needed
          }
        } catch (error) {
          console.warn('Error playing video:', error);
        }
      }
    }

    toggleVolume() {
      if (this.volumeButton) {
        this.volumeButton.setAttribute('muted', `${this.volumeButton.getAttribute('muted') == 'false' ? true : false}`); 
          
        if(this.volumeButton.getAttribute('muted') == 'true') {
          this.volumeButton.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.508.867C12.313.79 12.156.79 12 .79c-.313 0-.625.078-.86.313L5.868 5.75H2.625C1.57 5.75.75 6.61.75 7.625v3.71c0 1.017.82 1.837 1.875 1.837h3.242l5.274 4.687c.234.196.546.313.859.313.156 0 .313-.04.508-.117.43-.196.703-.664.703-1.133V2c0-.469-.274-.938-.703-1.133Zm-1.133 14.766-4.766-4.258H2.625v-3.71h3.984l4.766-4.259v12.227ZM20.789 9.5l1.836-1.836c.39-.39.39-.976 0-1.328-.352-.39-.938-.39-1.328 0L19.5 8.21l-1.875-1.875c-.39-.352-.977-.352-1.328 0-.39.39-.39.976 0 1.328L18.133 9.5l-1.836 1.836c-.39.39-.39.976 0 1.328.351.39.937.39 1.328 0l1.875-1.836 1.836 1.836c.352.39.937.39 1.289 0 .39-.351.39-.937 0-1.328L20.789 9.5Z" fill="#fff"></path></svg>';
          this.setVideosVolume(0);
        } else {
          this.volumeButton.innerHTML = '<svg width="20" height="17" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.758.867A1.349 1.349 0 0 0 11.25.75c-.313 0-.625.117-.86.352L5.118 5.75H1.875C.82 5.75 0 6.61 0 7.625v3.71c0 1.017.82 1.837 1.875 1.837h3.242l5.274 4.687c.234.313.546.391.859.391.156 0 .313 0 .508-.078.43-.235.742-.664.742-1.172V2c0-.469-.313-.938-.742-1.133Zm-1.133 14.766-4.766-4.258H1.875v-3.71h3.984l4.766-4.259v12.227Zm5.469-9.024a1.053 1.053 0 0 0-.586-.195.962.962 0 0 0-.742.352.942.942 0 0 0 .156 1.328c.43.351.703.86.703 1.406a1.85 1.85 0 0 1-.703 1.445.942.942 0 0 0-.156 1.328.962.962 0 0 0 .742.352c.195 0 .43-.078.586-.195.898-.742 1.406-1.797 1.406-2.93 0-1.094-.508-2.148-1.406-2.89Zm2.383-2.89c-.196-.117-.391-.196-.625-.196-.274 0-.508.118-.704.352-.351.39-.273.977.118 1.328 1.328 1.055 2.109 2.656 2.109 4.297 0 1.68-.781 3.281-2.11 4.336-.39.351-.468.937-.117 1.328.196.234.43.352.704.352.234 0 .43-.079.625-.196 1.757-1.445 2.773-3.554 2.773-5.82 0-2.227-1.016-4.336-2.773-5.781Z" fill="#fff"></path></svg>';
          this.setVideosVolume(.25);
        }
      }
    }

    async pauseAllVideos() {
      if (Array.from(this.activeModalVideos).length) {
        for (const video of this.activeModalVideos) {
          if (video && !video.paused) {
            try {
              // Check if the video is actually playing
              if (!video.paused && !video.ended && video.currentTime > 0) {
                video.pause();
              }
            } catch (error) {
              console.warn('Error pausing video:', error);
            }
          }
        }
      }
    }

    setVideosVolume(newVolume) {
      if (this.activeModalVideos) {
        this.activeModalVideos.forEach(video => {
          if (newVolume > 0) {
            video.muted = false;
            video.volume = newVolume;
          } else {
            video.muted = true;
            video.volume = newVolume;
          }
        });
      }
    }

    close(modal) {
      document.body.classList.remove('scroll-hidden--mobile');
      this.modalOverlay.classList.remove('td-video-modal__overlay--active');
      if (modal) {
        modal.removeAttribute('open');
      }
      this.pauseAllVideos();
      this.setVideosVolume(0);
    }
  }

  customElements.define('td-video-modal', tdVideoModal);
}
